const categories = {
  title: "内容分类",
  subtitle: "选择您感兴趣的分类，浏览相关内容",
  allCategories: "全部分类",
  articleCount: "篇文章",
  noArticles: "暂无相关文章",
};

export default categories;